import React from 'react';
import {
  Page,
  Text,
  View,
  StyleSheet,
} from '@react-pdf/renderer';
import { style } from '../../../components/pdf/fontstyles';

const styles = StyleSheet.create({
 
});

const PensionLetterPDF = ({result}) => (
  <View size="A4" style={style.page}>
    {/* Header */}
    <View>
      <Text style={[style.title, style.ArialBold, {fontSize: 12}]} >
        Pension Scheme for the Teaching Staff in Non-Government Secondary Schools
      </Text>
      <Text style={[style.title, style.ArialBold, {fontSize: 12}]}>
        (vide G.R.E. & S.W.D.NO. SSN3365-G, dated 4th November 1968)
      </Text>
    </View>

    <View style={style.solidLine}/>


    {/* Dispatch Line */}
    <View style={[style.paragraph, {fontSize:10}] }>
      <Text>Immediate: BY Regd. Post / Speed Post No: _____________</Text>
    </View>

    {/* From */}
    <View style={[style.paragraph, {marginTop: 20}]}>
      <Text >From:</Text>
      <Text >The Head Master, {result.institutionName}</Text>
    </View>

    {/* To */}
     <View style={[style.paragraph, {marginTop: 10}]}>
      <Text >To:</Text>
      <Text >Accountant General (A&E)-I, Maharashtra</Text>
      <Text >Maharishi Karve Road, Mumbai - 20</Text>
    </View>

    {/* Subject */}
       <View style={[style.paragraph, {marginTop: 10}]}>
      <Text>Subject : Pension case of {result.employeeName}, {result.designation}, {result.institutionName}</Text>
    </View>

    {/* Body */}
    <View style={styles.section}>
      <Text >Sir,</Text>
      <Text>
        I have the honor to forward herewith the pension papers of {result.employeeName}, who expired on / who is to retire on superannuation from {result.dateOfRetirement} afternoon. The papers are submitted as per the accompanying list for your kind favor of report on their title to pension at an early date.
      </Text>
    </View>

    {/* Closing */}
    <View style={[style.signature, {marginTop: 20, textAlign:'right'}]}>
      <Text >Yours faithfully,</Text>
      <Text style={[{marginTop: 50}]}>Head of Office</Text>

    </View>
    <View style={[style.paragraph, {marginTop: 10,}]}>
      <Text >Place: {result.placeOfRetirement}</Text>
      <Text >Date: </Text>
    </View>
     
    {/* Routing */}
    <View style={style.paragraph}>
      <Text >Respectfully submitted through:</Text>
      <Text style={[{marginLeft: 5}]}>1. Education Officer, Zilla Parishad, </Text>
       <Text style={[{marginLeft: 5}]}>2. The Deputy Director of Education, Kolhapur</Text>
    </View>
  </View>
);

export default PensionLetterPDF;
